import clsx from "clsx";
import parse from "html-react-parser";
import { ReactNode } from "react";
import styles from "./Text.module.scss";

export enum TextTag {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  H4 = "h4",
  H5 = "h5",
  H6 = "h6",
  DIV = "div",
  SPAN = "span",
}

interface TextProps {
  text?: string | undefined | number | ReactNode;
  as?: TextTag;
  size?: 1 | 2 | 3 | 4 | 5;
  white?: boolean;
  className?: string;
}

const Text = ({
  text,
  as: Tag = TextTag.DIV,
  size = 1,
  white,
  className,
}: TextProps) => {
  if (!text) return null;

  return (
    <Tag
      className={clsx(className, styles[`size${size}`], {
        [styles.white]: white,
      })}
    >
      {typeof text === "string" ? parse(text) : text}
    </Tag>
  );
};

export default Text;
